export default __webpack_public_path__ + "static/media/Piazza-Italia.cb0c8121.jpeg";